import React from 'react';
import S from './AboutCompany.module.scss';
import {Anchor, Breadcrumbs} from "@mantine/core";
import {useNavigate} from "react-router-dom";

const paragraph = [
    {
        id: "1",
        text: "Системная работа с промышленными предприятиями: ГМК, металлургия, машиностроение, нефтегазовая, химическая и энергетическая отрасли."
    },
    {
        id: "2",
        text: "Формирование деловых программ, отвечающих на актуальные запросы бизнеса и производства."
    },
    {
        id: "3",
        text: "Живой диалог между производственными компаниями, технологическими разработчиками, производителями оборудования, интеграторами и наукой."
    },
    {
        id: "4",
        text: "Поддержка импортонезависимых решений, цифровых технологий, ИБ, предиктивной аналитики, ESG-практик и современных подходов к ТОиР."
    },
]

export const AboutCompany = () => {
    const navigate = useNavigate();

    const items = [
        { title: 'Главная', url: '/' },
        { title: 'О компании', active: true },
    ].map((item, index) => (
        <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
            {item.title}
        </Anchor>
    ));

    return (
        <section id='aboutCompany'>
           <div className={S.content}>
               <div>
                   <Breadcrumbs>
                       {items}
                   </Breadcrumbs>
                   <div className={S.divInfo}>
                       <div className={S.title}>О КОМПАНИИ</div>
                       <div className={S.divText}>
                           <div className={S.text}>
                               ООО «ЭВОФОРУМ» — организатор ключевых деловых событий для тех, кто формирует будущее
                               промышленности: руководителей и профильных специалистов производственных предприятий, а
                               также поставщиков технологических и ИТ-решений. Наши форумы объединяют представителей
                               нефтегазовой, энергетической, металлургической, машиностроительной, горнодобывающей и
                               химической отраслей.
                           </div>
                           <div className={S.text}>
                               Мероприятия проводятся при поддержке ведущих промышленных компаний России, профильных
                               ассоциаций, органов власти и научных институтов.
                           </div>
                           <div className={S.text}>
                               Наша миссия — <span>создавать пространство для эффективного взаимодействия промышленности,
                               поставщиков технологических решений и оборудования, ИТ и инженерных решений, науки</span> —
                               где
                               участники могут не только делиться опытом, но и находить практические инструменты для
                               внедрения инноваций, повышения эффективности, устойчивости и конкурентоспособности.
                           </div>
                           <div className={S.text}><span>Наши приоритеты:</span></div>
                           <div>
                               {paragraph.map((item) => (
                                   <div key={item.id} className={S.paragraphDiv}>
                                       <li className={S.liStyle}/>
                                       <div className={S.text}>{item.text}</div>
                                   </div>
                               ))}
                           </div>
                           <div className={S.text}>
                               <span>Наша команда</span> — это специалисты с большим опытом в проведении отраслевых
                               мероприятий,
                               коммуникациях и стратегическом взаимодействии с предприятиями. Мы не просто организуем
                               форумы — мы строим <span>устойчивые деловые экосистемы</span>, в которых бизнес находит
                               партнёров,
                               решения и ресурсы для роста.
                           </div>
                           <div className={S.text}>
                               Мы открыты к партнёрству и готовы выстраивать долгосрочные деловые отношения с теми, кто
                               стремится развивать промышленность будущего — технологичную, экологичную и устойчивую.
                           </div>
                       </div>
                   </div>
               </div>
           </div>
        </section>
    );
};